import React, { useState, useEffect } from "react";
import i18n from "i18next";

import QRCode from "react-qr-code";
import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  Text,
  Button,
  Dialog,
  DialogTitle,
  DialogSurface,
  DialogContent,
  DialogBody,
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";

interface IQrCodePageProps {
  items: any[];
  isOpen: boolean;
  onDismiss: any;
}

function QrCodePage(props: IQrCodePageProps) {
  const windowSize = useWindowSize();

  return (
    <div>
      <Dialog open={props.isOpen}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {i18n.t<string>("qrCodesForAllItems")}
                <Button
                  appearance="transparent"
                  icon={<DismissRegular />}
                  onClick={() => props.onDismiss()}
                />
              </div>
            </DialogTitle>
            <DialogContent>
              <div style={{ marginTop: 20 }}>
                <hr
                  style={{
                    borderTop: "1px solid #ff6600",
                    padding: 0,
                    height: 1,
                  }}
                />
              </div>
              <StackShim tokens={{ childrenGap: 10 }}>
                {props.items.map((item) => {
                  return (
                    <div>
                      <StackShim horizontal tokens={{ childrenGap: 20 }}>
                        <QRCode
                          size={70}
                          value={
                            baseUrl +
                            `/addproduct?systemId=${item.produktId}&artikelId=${item.subArtikelId}&auftragId=${item.auftragId}&productId=${item.serialId}`
                          }
                        />
                        <StackShim>
                          <Text>
                            {i18n.t<string>("systemId")}: {item.produktId}
                          </Text>
                          <Text>
                            {i18n.t<string>("benennung")}:{" "}
                            {i18n.language.includes("de")
                              ? item.artikel.benennungDE
                              : item.artikel.benennungEN}
                          </Text>
                          <Text>
                            {i18n.t<string>("lieferdatum")}:{" "}
                            {new Date(item.ausgangsdatum).toLocaleDateString()}
                          </Text>
                        </StackShim>
                      </StackShim>
                      <div style={{ marginTop: 20 }}>
                        <hr
                          style={{
                            borderTop: "1px solid #ff6600",
                            padding: 0,
                            height: 1,
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </StackShim>
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

export default QrCodePage;
